import styles from './FounderCard.module.css';

interface FounderCardProps {
  imageSrc?: string;
  initials: string;
  name: string;
  paragraphs: readonly string[];
  tags: ReadonlyArray<{ label: string; href?: string }>;
  title: string;
}

export function FounderCard({
  imageSrc,
  initials,
  name,
  paragraphs,
  tags,
  title,
}: FounderCardProps) {
  return (
    <article className={styles.card}>
      {imageSrc ? (
        <img
          alt={`${name}, ${title}`}
          className={styles.photo}
          loading="lazy"
          src={imageSrc}
        />
      ) : (
        <div
          aria-label={`Photo placeholder for ${name}, ${title}`}
          className={styles.photo}
          role="img"
        >
          <span aria-hidden="true" className={styles.initials}>
            {initials}
          </span>
          <span className={styles.photoPill}>PHOTO PLACEHOLDER</span>
        </div>
      )}

      <div className={styles.copy}>
        <div className={styles.headingGroup}>
          <h3 className={styles.name}>{name}</h3>
          <p className={styles.title}>{title}</p>
        </div>

        <div className={styles.bio}>
          {paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>

        <div aria-label={`${name} profile details`} className={styles.tags}>
          {tags.map((tag) =>
            tag.href ? (
              <a className={styles.tag} href={tag.href} key={tag.label}>
                {tag.label}
              </a>
            ) : (
              <span className={styles.tag} key={tag.label}>
                {tag.label}
              </span>
            ),
          )}
        </div>
      </div>
    </article>
  );
}
